const data = {
  Football: 'футбол',
  Volleyball: 'волейбол',
  Basketball: 'баскетбол',
  Running: 'бег',
  Hockey: 'хоккей',
  TableTennis: 'настольный теннис',
  Golf: 'гольф',
  Pool: 'бильярд',
  Fitness: 'тренажерный зал',
  Bowling: 'боулинг',
  Boxing: 'бокс',
  Tennis: 'теннис',
  Driving: 'автодром',
  Badminton: 'бадминтон',
  Rugby: 'регби',
  AmericanFootball: 'американский футбол',
  Chess: 'шахматы',
  IceSkating: 'каток',
  Baseball: 'бейсбол',
  FieldHockey: 'хоккей на траве',
  Workout: 'воркаут',
  Barbershop: 'барбершоп',
  Squash: 'Падел и Сквош',
  Darts: 'Дартс',
  Other: 'Другое',
  Swimming: 'Плавание',
  Skate: 'Скейтпарки',
  Climbing: 'Скалодром',
  Snow: 'Лыжи и сноуборд',
  Rent: 'Прокат снаряжения',
  Dance: 'Хореография',
  Paintball: 'Пейнтбол',
  Lasertag: 'Лазертаг',
};

const reducer = (state = data) => state;

export default reducer;
